<form [formGroup]='dateFormGroup' class='input-timestamp' (click)="$event.stopPropagation()">
  <div class='row w-100 m-0'>
    <label *ngIf='label || tooltipInfo'>
      <span *ngIf="label" [innerHTML]="label + (isRequired ? '*' : '')"></span>
      <ion-icon
        *ngIf="tooltipInfo"
        name='{{IconInfoCircle}}'
        ngbTooltip="{{tooltipInfo}}"
        placement="bottom"
        container='body'
        [ngStyle]="{'font-size': '16px'}" class='ion-icon d-inline-flex' title=''></ion-icon>
    </label>
    <div class='input-group input-group-sm w-100 p-0' style="height: 25px">
      <input id='date-input' #b
             formControlName='dateTimeToShow'
             class='form-control form-control-sm'
             [placeholder]='placeholder'
             [class.is-invalid]='dateFormGroup.invalid'>

      <!--      [class.is-valid]='dateFormGroup.valid'-->
      <input class='form-control form-control-sm border-0'
             style="width: 0;min-width: 0;padding: 0; max-width: 0;"
             name='dp'
             ngbDatepicker
             [minDate]="minDate"
             #d='ngbDatepicker'
             formControlName='date'
             [container]="'body'"
             [footerTemplate]='timePickerTemplate'>
      <div class='input-group-text p-0' style="height: inherit; width: 40px;">
        <button type='button' class='btn text-muted'
                [disabled]='isDisabled' (click)='onCalendarIcon(d)'>
          <ion-icon name='calendar-outline' class='ion-icon hstack' title='' style="font-size: 18px"></ion-icon>
        </button>
      </div>
    </div>
    <span class='small text-danger p-0' *ngIf='!dateFormGroup.pristine && dateFormGroup.invalid'>Invalid date</span>
  </div>
</form>

<ng-template #timePickerTemplate>
  <div *ngIf="showTimePicker" class='w-100 d-flex flex-row justify-content-center'
       [formGroup]='dateFormGroup'>
    <ngb-timepicker formControlName='time'></ngb-timepicker>
  </div>
</ng-template>
